import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import {MenuItemInfo, TakeUntilHelper} from '@aam/shared';
import {AcsGroupFormValues} from '@objects-module/group-editors/group-edit-acs-groups/acs-groups.types';
import {translate} from '@ngneat/transloco';
import {
  FormControl,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import {ReaderGroupFormValues} from '@objects-module/group-editors/reader-group/reader-group.types';
import {changeControlStatus} from '@shared-module/utils/forms';
import {startWith, takeUntil, tap} from 'rxjs/operators';
import {debounceTime, distinctUntilChanged} from 'rxjs';

@Component({
  selector: 'app-group-edit-acs-groups',
  templateUrl: './group-edit-acs-groups.component.html',
  styleUrls: ['./group-edit-acs-groups.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupEditAcsGroupsComponent
  extends TakeUntilHelper
  implements OnInit
{
  @Output() changeValues = new EventEmitter<{
    values: AcsGroupFormValues;
  }>();
  @Output() close = new EventEmitter();
  @Output() save = new EventEmitter();

  emitClose() {
    this.close.emit();
  }

  emitSave() {
    this.save.emit();
  }

  tPrefix = 'objectsModule.acs-group-group.';
  menuItems: MenuItemInfo[] = [
    {
      id: 1,
      label: translate(`${this.tPrefix}main`),
    },
  ];

  useActive = new FormControl();
  active = new FormControl();

  formGroup = new UntypedFormGroup({
    useActive: this.useActive,
    active: this.active,
  });

  ngOnInit(): void {
    this.subscribeOnFormChange();
  }

  updateDisabledStatuses(values: AcsGroupFormValues) {
    const {controls} = this.formGroup;
    changeControlStatus(values.useActive, controls.active);
  }

  subscribeOnFormChange() {
    this.formGroup.valueChanges
      .pipe(
        startWith({}),
        tap((values: AcsGroupFormValues) => {
          this.updateDisabledStatuses(values);
        }),
        debounceTime(500),
        distinctUntilChanged(),
        tap(values => {
          this.changeValues.emit({values});
        }),
        takeUntil(this.end$)
      )
      .subscribe();
  }
}
